import { render, staticRenderFns } from "./discount-management.vue?vue&type=template&id=b8cbbdbe"
import script from "./discount-management.vue?vue&type=script&lang=js"
export * from "./discount-management.vue?vue&type=script&lang=js"
import style0 from "./discount-management.vue?vue&type=style&index=0&id=b8cbbdbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports